import { ATTACHMENT_ALLOWED_MIME_TYPES } from "@rakazo/contracts";
import { OFFICE_FILE_TYPES } from "./file-type-badge";

/**
 * Android's document picker can filter out CSV files when the accept attribute
 * combines many MIME types. Allow the picker to show files on Android; the
 * attachment preparation and API still reject unsupported formats and sizes.
 */
export function attachmentPickerAccept(userAgent: string): string {
  if (/\bAndroid\b/i.test(userAgent)) return "*/*";
  // Office types by extension as well: Safari and some macOS pickers report them unreliably.
  const office = OFFICE_FILE_TYPES.flatMap((type) => [type.mimeType, type.extension]);
  return [...new Set([...ATTACHMENT_ALLOWED_MIME_TYPES, ...office, ".zip", ".csv"])].join(",");
}
